import { render, staticRenderFns } from "./HousemateGroup.vue?vue&type=template&id=13877d0f"
import script from "./HousemateGroup.vue?vue&type=script&lang=js"
export * from "./HousemateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports